import axios from 'axios';

export function setPassword({
  password,
  passwordResetCode,
  userId,
}: {
  password: string;
  passwordResetCode: string;
  userId: number;
}) {
  return axios.post(`/api/users/${userId}/password`, {
    password,
    passwordResetCode,
  });
}
